export default {
  HANDLE_SET_LINK_CREATOR_CAMPAIGN: 'handleSetLinkCreatorCampaign',
  HANDLE_SET_LINK_CREATOR_LANGUAGE: 'handleSetLinkCreatorLanguage',
  HANDLE_ANCHOR_TEXT_CHANGE: 'handleAnchorTextChange',
  HANDLE_SUCCESS_GET_SITES: 'handleSuccessGetSites',
};



// WEBPACK FOOTER //
// ./src/app/main/link-creator/constants/action-types.js